import styled from '@emotion/styled'
import { Check } from 'app/components/Icons'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { styles } from 'app/theme'
import { compact } from 'lodash'
import React, { memo, useContext } from 'react'

export interface Props {
  modalStatus?: boolean
}

export const Benefits = memo(function Benefits({ modalStatus }: Props) {
  const { benefits, languageCode } = useContext(HeaderContext) as any

  if (!benefits) return

  const benefitsList = compact(benefits?.list).map(({ iconset_id }: any) => {
    const translation = iconset_id?.translations?.filter(
      (t: any) => t?.languages_code?.code === languageCode,
    )[0]

    const icon = iconset_id?.icon?.file?.publicURL || undefined
    const title = translation?.label || undefined

    return {
      icon,
      title,
    }
  })

  return (
    <Container
      className={modalStatus ? 'open item-benefits' : 'item-benefits'}
      onClick={(e) => e.stopPropagation()}
    >
      {benefitsList ? (
        <Box>
          {benefits.title ? (
            <BenefitsTitle className="item-title">
              {benefits.title}
            </BenefitsTitle>
          ) : null}

          <Items row wrap space="between">
            {benefitsList.map((item: any, index: any) => (
              <Item className="item-element" key={index} row dial={4}>
                <IconWrap dial={5}>
                  {item.icon ? (
                    <Icon
                      src={item.icon}
                      alt={item.title}
                      width="18"
                      height="18"
                    />
                  ) : (
                    <Check />
                  )}
                </IconWrap>
                {item.title}
              </Item>
            ))}
          </Items>
        </Box>
      ) : null}
    </Container>
  )
})

const Box = styled.div``

const BenefitsTitle = styled.div`
  ${styles.title.small}

  text-transform: none;
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  text-align: center;
  margin-bottom: 2.25rem;

  @media (max-width: 1439px) {
    margin-bottom: 1.5rem;
  }
`

const Items = styled(FlexBox)`
  text-align: left;
`

const Item = styled(FlexBox)`
  ${styles.description.light}

  width: 50%;
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  margin-bottom: 1rem;

  &:last-of-type {
    margin-bottom: 0;
  }

  svg {
    width: 0.5rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};
  }

  @media (max-width: 1439px) {
    margin-bottom: 0.5rem;
    line-height: 1.125rem;
  }
`

const IconWrap = styled(FlexBox)`
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  margin-right: 0.75rem;
  background-color: ${({ theme }) => theme.colors.variants.neutralLight4};
`

const Icon = styled.img`
  margin-right: 1.5rem;
`

const Container = styled.div`
  margin-top: 5.25rem;
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  overflow: hidden;
  padding: 0;
  position: relative;
  opacity: 0;
  transition: 0.6s 0.6s ease-in-out;
  &.open {
    opacity: 1;
  }

  @media (max-width: 1439px) {
    margin-top: 3rem;
  }
`
